import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-best-interactive-flat-panels-virsa-ifp',
  templateUrl: './best-interactive-flat-panels-virsa-ifp.component.html',
  styleUrls: ['./best-interactive-flat-panels-virsa-ifp.component.scss']
})
export class BestInteractiveFlatPanelsVirsaIfpComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('Best Interactive Flat Panels for Schools, Colleges & Offices | Virsa Interactive Flat Panels');
    this.metaService.updateTag({ name: 'description', content: 'Discover the best interactive flat panels for schools, colleges, offices, and training centers. Buy Virsa IFP (55” to 110”) with 4K display and smart features.' });
    this.metaService.updateTag({ name: 'keywords', content: 'Best interactive flat panels, Best panels for schools, Best interactive flat panels for colleges, Virsa Interactive Flat Panles, Buy interactive flat panel, Interactive flat panel for office, Smart panels for training centers, Interactive display India, 4K interactive flat panel, Digital classroom panels' });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
